import { Box, Button, ButtonGroup, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import SelectBoxSearch from "src/shared/components/select_box_search";
import { Task } from "../../interface";
import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";
import { tableStyles } from "src/shared/util/tableStyles";

const FieldsViews = ({ task, listForConfig, onChange }: { task: Task | undefined, listForConfig: any, onChange: any }) => {

    const columns: GridColDef[] = [
        // { field: "id", headerName: "ID", flex: 0.1 },
        { field: "locationName", headerName: "Pozo", flex: 0.3 },
        { field: "activityType", headerName: "Tipo de Actividad", flex: 0.3 },
        { field: "users", headerName: "Ingenieros", flex: 0.3 },
        { field: "comments", headerName: "Comentario", flex: 1}
    ]


    return (
        <Grid size={12}>
            <DataGrid
                rows={task?.fieldActivities || []}
                columns={columns}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    mt: 2,
                    height: {
                        md: `calc(100vh - 395px)`,
                        lg: `calc(100vh - 395px)`,
                        xl: `calc(100vh - 400px)`,
                    },
                    ...tableStyles,
                }}
                getRowId={(row) => row.id}
            />
        </Grid>
        // <Grid container spacing={2}>
        //     {task && task?.fieldActivities?.length > 0 ? (
        //         <Grid size={12} className="table_reports">
        //             <div className="header">
        //                 <div>Pozo</div>
        //                 <div>Cuadrilla</div>
        //                 <div>Ingenieros</div>
        //                 <div>Comentario</div>
        //             </div>
        //             {task.fieldActivities.map((fieldActivity, index) => (
        //                 <div className="body_list" key={index}>
        //                     {/* TODO VALIDATE */}
        //                     <div className="body_row">
        //                         <div>{fieldActivity.locationName}</div>
        //                         <div>{fieldActivity.activityType}</div>
        //                         <div>{fieldActivity.users}</div>
        //                         <div>{fieldActivity.comments}</div>
        //                     </div>
        //                 </div>
        //             ))}
        //         </Grid>
        //     ):(
        //         <Grid size={12}>
        //             <Box
        //                 sx={{
        //                     display: "flex",
        //                     justifyContent: "center",
        //                     alignItems: "center",
        //                     height: "100px",
        //                 }}
        //             >
        //                 <Typography variant="body1" color="initial">
        //                     No hay actividades
        //                 </Typography>
        //             </Box>
        //         </Grid>
        //     )}

        // </Grid>
    );
};

export default FieldsViews;
